export enum ReviewsSearchStort {
    MOST_RELEVANT = "MOST_RELEVANT",
    MOST_HELPFUL = "MOST_HELPFUL",
    SCORE_DESC = "SCORE_DESC",
    SCORE_ASC = "SCORE_ASC",
    MOST_RECENT = "MOST_RECENT"
}
